//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BASIC } from "@/config/constant"
import promise from '@/axios/promise'
import { formatTime } from "@/utils/common"
export default {
	props: ['message'],
	data() {
		return {
			k: '',
			taskHis: ''
		}
	},
	created() {
		this.k = this.message;
		// alert(this.k)
		this.getApprData();
	},
	methods: {
		getApprData() {
			promise({
				url: BASIC + "/task/getProcessHisByBusKey",
				method: "get",
				async: true,
				params: {
					businessKey: this.k
				}
			}).then(res => {
				var data = res.data.reverse();
				this.taskHis = data;
			});
		}
	},
	filters: {
		formatDate(time) {
			var date = new Date(time);
			return formatTime(date, 'yy-MM-dd hh:mm');
		}
	},
}



// WEBPACK FOOTER //
// ./src/components/diyAssembly/apprDaily.vue